module.exports = __webpack_public_path__ + "static/media/sonder7.b381b0f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/article/sonder7.jpg
// module id = 386
// module chunks = 0